import React, { FunctionComponent } from 'react'
import { Dialog } from '../../etc/Dialog/Dialog'
import { objectActions } from '../../../redux/data/object/object-actions'
import OkCancel from '../../controls/OkCancel/OkCancel'
import BindDialog from '../projects/ProjectPage/BindDialog/BindDialog'
import { projectActions } from '../../../redux/data/project/project-actions'
import ProjectCloseDialog from '../../data-components/dialogs/ProjectCloseDialog/ProjectCloseDialog'
import { flow } from 'fp-ts/es6/function'
import { taskActions } from '../../../redux/data/task/task-actions'
import { useRootDispatch, useRootSelector } from '../../../utils/hooks'
import CommentElement from '../../data-components/elements/CommentElement/CommentElement'
import { historyActions } from '../../../redux/global/history/history-actions'
import { archiveActions, ArchiveEditState } from '../../../redux/pages/archive'
import ArchiveDialog from '../archive/ArchivePage/ArchiveDialog/ArchiveDialog'
import { Colors } from '../../../styles'
import ProjectLine from '../projects/ProjectList/ProjectLine/ProjectLine'
import UnarchiveIcon from 'files/archive/unarchive.svg'
import { ObjectEditState } from '../../../redux/data/object/object-reducer'
import { ProjectEditState } from '../../../redux/data/project/project-reducer'
import { TaskEditState } from '../../../redux/data/task/task-reducer'
import { CommentEditState } from '../../../redux/global/history/history-reducer'
import ObjectName from '../../etc/ObjectName/ObjectName'
import ReserveDialog from '../archive/ArchivePage/ReserveDialog/ReserveDialog'

const DialogsController: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const taskEditState = useRootSelector(state => state.data.task.editState)
    const objectEditState = useRootSelector(state => state.data.object.editState)
    const projectEditState = useRootSelector(state => state.data.project.editState)
    const commentEditState = useRootSelector(state => state.global.history.editState)
    const archiveEditState = useRootSelector(state => state.pages.archive.editState)

    return <>
        {
            ObjectEditState.match({
                delete: ({object}) => <Dialog
                    header={'Подтвердите удаление объекта:'}
                    subheader={<ObjectName object={object}/>}
                    onClose={() => dispatch(objectActions.cancelEdit())}
                    actions={({ onClose }) => <OkCancel
                        color={Colors.red}
                        onOk={() => dispatch(objectActions.remove.request())}
                        onCancel={onClose}
                    />}
                />,
                duplicate: ({object}) => <Dialog
                    header={'Подтвердите дублирование объекта'}
                    subheader={<ObjectName object={object}/>}
                    onClose={() => dispatch(objectActions.cancelEdit())}
                    actions={({onClose}) => <OkCancel
                        onOk={() => {
                            dispatch(objectActions.cancelEdit())
                            dispatch(objectActions.duplicate(object))
                        }}
                        onCancel={onClose}
                        text={'Дублировать'}
                    />}
                />
            }, () => null)(objectEditState)
        }
        {
            ProjectEditState.match({
                bind: ({project}) => <BindDialog
                    project={project}
                    onOk={changes => dispatch(projectActions.update.request(changes, {}))}
                    onClose={() => dispatch(projectActions.cancelEdit())}
                />,
                close: ({project}) => <ProjectCloseDialog
                    project={project}
                    onChange={flow(projectActions.close.request, dispatch)}
                    onCancel={() => dispatch(projectActions.cancelEdit())}
                />,
                delete: ({project}) => <Dialog
                    header={'Подтвердите удаление проекта: ' + project.name}
                    onClose={() => dispatch(projectActions.cancelEdit())}
                    actions={({ onClose }) => <OkCancel
                        color={Colors.red}
                        onOk={() => dispatch(projectActions.remove.request())}
                        onCancel={onClose}
                    />}
                />
            }, () => null)(projectEditState)
        }
        {
            TaskEditState.is.delete(taskEditState) && <Dialog
                onClose={() => dispatch(taskActions.cancelEdit())}
                header={`${taskEditState.message}: ${taskEditState.task.type.name}`}
                actions={({ onClose }) => <OkCancel
                    color={Colors.red}
                    onCancel={onClose}
                    onOk={() => dispatch(taskActions.remove.request())}
                />}
            />
        }
        {
            CommentEditState.is.delete(commentEditState) && <Dialog
                header={'Подтвердите удаление комментария'}
                onClose={() => dispatch(historyActions.cancelEdit())}
                actions={({ onClose }) => <OkCancel
                    color={Colors.red}
                    onOk={() => dispatch(historyActions.delete.request())}
                    onCancel={onClose}
                />}
            >
                <CommentElement comment={commentEditState.comment}/>
            </Dialog>
        }
        {
            ArchiveEditState.match({
                unarchive: ({project}) => <Dialog
                    header={'Подтвердите разархивирование'}
                    actions={({onClose}) => <OkCancel
                        color={Colors.purpleMedium}
                        onCancel={onClose}
                        icon={<UnarchiveIcon/>}
                        text={'Разархивировать'}
                        onOk={() => dispatch(archiveActions.unarchive.request(project))}
                    />}
                    onClose={() => dispatch(archiveActions.cancelEdit())}
                >
                    <ProjectLine minimal projectId={project.id}/>
                </Dialog>,
                archive: ({projects}) => <ArchiveDialog
                    projects={projects}
                    onArchive={flow(archiveActions.archive.request, dispatch)}
                    onClose={() => dispatch(archiveActions.cancelEdit())}
                />,
                reserve: () => <ReserveDialog
                    onReserve={flow(archiveActions.reserve.request, dispatch)}
                    onClose={() => dispatch(archiveActions.cancelEdit())}
                />
            }, () => null)(archiveEditState)
        }
    </>
}

export default DialogsController